/**
 * User-facing message for failed POST/PATCH /api/rooms.
 * @param {Response} res
 * @param {(k: string) => string} t
 */
export async function formatRoomFormApiError(res, t) {
  const j = await res.json().catch(() => ({}));
  const status = res.status;
  if (status === 503 || status === 502) {
    return t('roomForm.error503');
  }
  if (status === 504) {
    return t('roomForm.error504') || t('roomForm.error503');
  }
  if (status === 400) {
    const errCode = (j.error != null && String(j.error)) || '';
    if (errCode === 'Invalid typeKey' || (errCode && errCode.toLowerCase().includes('typekey'))) {
      return t('roomForm.errorTypeKey');
    }
    if (errCode === 'Invalid iconKey' || (errCode && errCode.toLowerCase().includes('iconkey'))) {
      return t('roomForm.errorIconKey');
    }
    if (errCode === 'name required' || (j.message && String(j.message).toLowerCase().includes('name required'))) {
      return t('roomForm.nameRequired');
    }
    const detail = [j.error, j.message].filter((x) => x != null && String(x).trim() !== '').join(' — ');
    if (detail) {
      return `${t('roomForm.error400')}: ${detail}`;
    }
    return t('roomForm.error400');
  }
  if (status === 403) {
    return j.message || t('roomForm.error403');
  }
  if (status === 401) {
    return t('roomForm.error401') || 'Unauthorized';
  }
  if (j.message || j.error) {
    return String(j.message || j.error);
  }
  return t('roomForm.errorHttp', String(status));
}
